import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { BaseComponent } from '../base/base.component';

@Component({
  selector: 'app-roshd',
  templateUrl: './roshd.component.html',
  styleUrls: ['./roshd.component.scss'],
})
export class RoshdComponent extends BaseComponent implements OnInit {
  constructor(private title: Title) {
    super();
    this.title.setTitle('کارگزاری آبان | صندوق رشد پایدار ');
  }

  ngOnInit(): void {
    super.ngOnInit();
  }
}
